
import { Vue } from "vue-class-component";
export default class Test extends Vue {
  data() {
    this.$router.push({
      path: "/auto_test",
    });
    return {};
  }
}
